import Component from "../../lib/component";
import { crumple } from "../../helpers/element";
import { UsernameField } from "./components/username_field";

export const SignupFormConfig = {
  componentTypeKey: 'SignupForm',
  baseHtmlClass: 'signup_form',
  selector: '.signup_form',

  datasetConfigKey: 'signup_form__config',
  usernameIndicatorConfigDatasetConfigKey: 'username_indicator_config',

  initializedHtmlClass: 'signup_form--inited',
  notInitializedSelector: '.signup_form:not(.signup_form--inited)',

  loadedEventName: 'Rankers.Login.SignupForm:Loaded',
  initializedEventName: 'Rankers.Login.SignupForm:Initialized',
};

export class SignupForm extends Component {

  static get config() {
    return SignupFormConfig;
  }

  constructor(id_or_element) {
    super({
      element: id_or_element,
      config: SignupForm.config,
    });

    this.setDatasetConfig(SignupForm.config.datasetConfigKey);
    this.usernameIndicatorConfig = this.getDatasetConfigValue(SignupForm.config.usernameIndicatorConfigDatasetConfigKey);

    this.hpElement = this.element.querySelector(".signup_form__nickname_input");
    this.usernameField = getUsernameField(this);

    this.render();
  }

  render() {
    if (this.hpElement) this.renderHp();
    if (this.usernameField) this.usernameField.render();
  }

  renderHp() {
    crumple(this.hpElement);
  }
}

function getUsernameField(signupForm) {
  const element = signupForm.element.querySelector(
    UsernameField.config.selector,
  );
  if (!element) return null;
  return new UsernameField(element, signupForm);
}
